<p-menubar [model]="items" styleClass="navbar">
    <ng-template #start>
         <button text="true" pButton (click)="toggleSidebar()" class="menu-button" pTooltip="Menu" severity="contrast">
            <i-tabler [name]="'menu-2'"></i-tabler>
        </button>
        <!-- <p-button icon=""/> -->
        <a (click)="navigateToLanding()" class="cursor-pointer"><img src="./assets/imgs/logo.png" alt="" class="h-3rem"></a>
    </ng-template>
    <ng-template #item let-item let-root="root">
    </ng-template>
    <ng-template #end>
        <div class="flex items-center gap-2">
            <p-button
              [text]="true"
              (onClick)="profileOverlay.toggle($event)"
              styleClass="profile-option relative p-2 bg-white"
            >
              <p-avatar
                image="assets/imgs/avatar-04.jpg"
                shape="circle"
                ariaLabel="Profile Pic"
              />
            </p-button>
            
            <p-overlayPanel #profileOverlay [style]="{ 'box-shadow': 'none' }">
                <span>
                    <div class="flex flex-column align-items-center">
                        <h3 class="mt-2 mb-0"> {{ username }} </h3>
                    </div>
                </span>
                <hr>
                <p-button 
                    styleClass="w-full flex justify-content-center p-button-outlined white-space-nowrap"
                    [outlined]="true" 
                    label="Logout" 
                    (onClick)="logout()">
                </p-button>
            </p-overlayPanel>
            
          </div>
          
    </ng-template>
</p-menubar>
<p-confirmDialog />